import Promise from './index';

var global = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!global.Promise) {
  global.Promise = Promise;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise-polyfill/src/polyfill.js
// module id = null
// module chunks = 